/* @flow */
import {
  BODY_AD_WORD_COUNT_THRESHOLD,
  BODY_AD_WORD_COUNT_THRESHOLD_INITIAL
} from './__constants__';
import getSectionAdList from './getSectionAdList';

import type {
  Section,
  SectionAdListOptions,
  SectionAdListTuple,
  SectionContent
} from './__types__';

const defaultCountWords = (content: string): number => content.split(' ').length;

const wordCountCache = {};
export const getWordCount = (
  content: SectionContent,
  countWords: string => number = defaultCountWords
): number => {
  if (typeof content !== 'string') { // not a text section
    return 0;
  }
  if (!wordCountCache[content]) {
    wordCountCache[content] = countWords(content);
  }
  return wordCountCache[content];
};

export default (
  options: SectionAdListOptions
): SectionAdListTuple => {
  // This will accumulate as the loop in `getSectionAdList` calls
  // `didNotDisplayAd`.
  let accumulatedWordCount = 0;

  return getSectionAdList(options, {

    canDisplayAd: (adCount: number, section: Section): bool => {
      const wordCountAdThreshold = adCount > 0
        ? BODY_AD_WORD_COUNT_THRESHOLD
        : BODY_AD_WORD_COUNT_THRESHOLD_INITIAL;
      const newWordCount = accumulatedWordCount + getWordCount(section.content);
      return newWordCount >= wordCountAdThreshold;
    },

    didDisplayAd: (): void => {
      accumulatedWordCount = 0;
    },

    didNotDisplayAd: (section: Section): void => {
      accumulatedWordCount += getWordCount(section.content);
    }

  });
};
